import { getChapterRootFromXml } from "../GuidelineNav/menuGeneration";
import { isNullOrEmpty } from "../../utils/isNullOrEmpty";
import { cleanMsPath, compareItemForAttr } from "../../hooks/tableOfContentsHooks/tableOfContents";
import { getMenuItems } from "../GuidelineNav/guidelineMenuGenerator";

// After find the matched node with msPath
// All the parent nodes are stored in traces
// Filter the traces from child to parent to figure out which is the first node of the chapter
function filterTopNode(traceNodes) {
  if (isNullOrEmpty(traceNodes)) return null;

  for (const node of [...traceNodes].reverse()) {
    if (node.chapter === true) {
      return node;
    }
  }
  console.warn("Table of Content showing the last matched topic");
  return traceNodes.at(-1);
}

function filterUmbrellaNode(traceNodes) {
  if (isNullOrEmpty(traceNodes)) return null;

  for (const node of [...traceNodes].reverse()) {
    if (node.umbrella === true) {
      return node;
    }
  }
  return {};
}

// This function is to exclude any children node that contains tandf within class name
function removeTnfNodes(chapterNode) {
  if (!chapterNode || !Array.isArray(chapterNode.children)) return chapterNode;

  const filteredChildren = chapterNode.children
    .filter((child) => !child.className?.includes("tandf"))
    .map(removeTnfNodes);

  return {
    ...chapterNode,
    children: filteredChildren,
  };
}

function findChapter(jsonObj, targetMsPath) {
  let targetNode;
  let traces;
  for (const item of jsonObj) {
    const processedItem = { ...item };
    targetNode = findNodeByMsPath(processedItem, targetMsPath);

    if (targetNode) {
      break;
    }
  }
  if (!targetNode) {
    console.warn("Unable to find node via msPath value, hence unable to display TOC menus");
  }
  if (targetNode) {
    traces = findPathToItem(jsonObj, targetNode);
  }

  const chapterNode = filterTopNode(traces);
  const umbrellaNode = filterUmbrellaNode(traces);
  return {
    chapterNode: (chapterNode && removeTnfNodes(chapterNode)) || {},
    umbrellaNode: umbrellaNode || {},
    // The exact node that matched the full URL (including topicfile).  Used to
    // pre-select the correct TOC item without relying on scroll detection.
    activeNode: targetNode || null,
  };
}

function findPathToItem(root, target) {
  const path = [];
  for (const node of root) {
    findMatchedItem(node, target, path);
  }
  return path.reverse();
}

function findMatchedItem(node, target, path) {
  if (isNullOrEmpty(node)) return false;

  if (isSameItem(node, target)) {
    path.push(node);
    return true;
  }

  if (node.children && node.children.length > 0) {
    for (const child of node.children) {
      if (findMatchedItem(child, target, path)) {
        path.push(node);
        return true;
      }
    }
  }
  return false;
}

function findNodeByMsPath(node, targetMsPath) {
  if (isNullOrEmpty(node) || isNullOrEmpty(targetMsPath) || isNullOrEmpty(node.msPath)) return null;
  // XML mpspath values may contain parentheses (e.g. "thoracic-spine-(upper-back-pain")
  // but updateURL.js strips them before pushing to the browser URL, so normalise both sides.
  const nodePath = cleanMsPath(node.msPath.toLowerCase()).replace("(", "").replace(")", "");
  const normalizedTargetPath = targetMsPath.toLowerCase().startsWith("/viewtopic")
    ? targetMsPath.toLowerCase()
    : "/viewtopic" + targetMsPath.toLowerCase();

  const targetPath = cleanMsPath(normalizedTargetPath);

  if (nodePath === targetPath) {
    return node;
  }

  if (node.children && node.children.length > 0) {
    for (let child of node.children) {
      let found = findNodeByMsPath(child, targetMsPath);
      if (found) {
        return found;
      }
    }
  }
  return null;
}

export default function generateTocForCurrentPath(xmlString, currentPath) {
  const chapter = getChapterRootFromXml(xmlString);
  const menuData = getMenuItems(chapter);
  if (menuData) {
    const { chapterNode, activeNode } = findChapter(menuData, currentPath);
    return { chapterNode, activeNode };
  }
  return { chapterNode: null, activeNode: null };
}

export function getUmbrellaMenuItems(xmlString, currentPath) {
  const chapter = getChapterRootFromXml(xmlString);
  const menuData = getMenuItems(chapter);
  if (menuData) {
    return findChapter(menuData, currentPath).umbrellaNode;
  }
}

export function isSameItem(item1, item2) {
  const attributes = ["id", "href", "msPath", "title"];
  return attributes.every((attr) => {
    return compareItemForAttr(item1, item2, attr);
  });
}
